module.exports = __webpack_public_path__ + "static/media/copyIcon.4df13a5f.svg";